import { storage } from '@abyss/web/tools/storage';

import { adobeLinkTrackEvent } from '../../../../../../common/AdobeTagging/adobeLinkTrackEvent';
import {
  Constants,
  NEW_TAB_CONFIRMATION,
  ProviderTypes,
} from '../../../../../../common/Constants';
import { ConstantsRoutes } from '../../../../../../common/ConstantsRoutes';
import { convertObjectToUrlParams } from '../../../../../../common/Utils';
import { CustomAttributesBlock } from '../../../../../../common/Utils/adobeTrackUtils/adobeTrackUtils';

export const openTabOrNavigateOnClick = ({
  providerId,
  navigate,
  options,
  chipStoreValues,
  setDetailsStore,
  customAttributesBlock,
  isTieredPlan = false,
  providerTierDesignation = '',
  llmStatus = '',
  isIFPEarlyPay = false,
  isGuestUser = false,
  isGuestWithPlan = false,
}: {
  providerId: string;
  navigate: (path: string) => void;
  options: any;
  chipStoreValues: { chipValue: string; coverageType: string };
  setDetailsStore: (values: any) => void;
  customAttributesBlock?: CustomAttributesBlock;
  isTieredPlan?: boolean;
  providerTierDesignation?: string;
  llmStatus?: string;
  isIFPEarlyPay?: boolean;
  isGuestUser?: boolean;
  isGuestWithPlan?: boolean;
}) => {
  const detailsRouteMap = {
    [ProviderTypes.MEDICALGROUP.toLowerCase()]:
      ConstantsRoutes.PROVIDER_GROUP_DETAILS.path,
    [ProviderTypes.ORGANIZATION.toLowerCase()]:
      ConstantsRoutes.FACILITY_DETAILS.path,
    [ProviderTypes.PRACTITIONER.toLowerCase()]:
      ConstantsRoutes.PROVIDER_DETAILS.path,
  };

  const detailsRoute =
    detailsRouteMap[options?.providerType?.toLowerCase()] || '';

  const detailsStoreValues = {
    providerId,
    isTieredPlan,
    providerTierDesignation,
    llmStatus,
  };
  setDetailsStore(detailsStoreValues);

  storage.session.set(
    Constants.STORAGE_KEYS.SESSION.SELECTED_PROVIDER_ID,
    providerId
  );
  adobeLinkTrackEvent({
    name: 'view provider',
    location: `modal:${NEW_TAB_CONFIRMATION}`,
    type: 'internal',
    destinationUrl: `${detailsRoute}`,
    customAttributesBlock,
  });
  // @ts-expect-error This is a eslint error suggested by --fix command
  const urlParams = convertObjectToUrlParams(customAttributesBlock, {
    chipValue: chipStoreValues.chipValue,
    coverageType: chipStoreValues.coverageType,
    ...detailsStoreValues,
    ...(options?.suppressPremium && {
      suppressPremium: options.suppressPremium,
    }),
    ...(options?.suppressCostEfficiency && {
      suppressCostEfficiency: options.suppressCostEfficiency,
    }),
    ...(options?.recommendationRadius && {
      recommendationRadius: options.recommendationRadius,
    }),
  });

  if (options && options?.openInNewTab) {
    const getBasePath = (): string => {
      const currentPath = window.location.pathname;
      const resultsIndex = currentPath.indexOf('/results/');

      if (resultsIndex !== -1) {
        return currentPath.substring(0, resultsIndex);
      }

      const pathSegments = currentPath.split('/').filter(Boolean);
      if (pathSegments.length > 0) {
        const firstSegment = pathSegments[0];
        const knownBasePaths = ['findcare', 'guest', 'guest-with-plan', 'laww'];
        if (knownBasePaths.includes(firstSegment)) {
          return `/${firstSegment}`;
        }
      }

      if ((isIFPEarlyPay || isGuestUser) && !isGuestWithPlan) return '/guest';
      if (isGuestWithPlan) return '/guest-with-plan';
      return '/findcare';
    };
    const cleanRoute = detailsRoute.endsWith('/')
      ? detailsRoute.slice(0, -1)
      : detailsRoute;
    window.open(
      `${window.location.origin}${getBasePath()}${cleanRoute}${urlParams}`,
      '_blank'
    );
  } else {
    navigate(`${detailsRoute}${urlParams}`);
  }
};
